// funciones para manejar fechas en formato AAAAMMDD numerico


function toInput(fecha) {
  // fecha es de tipo number o string (YYYMMDD), devuelve  YYYY-MM-DD para usar en entrada de datos
  fecha = fecha.toString();
  if (fecha) {
    return fecha.substr(0, 4) + "-" + fecha.substr(4, 2) + "-" + fecha.substr(6, 2);
  } else return null;
}

function toOutput(fecha) {
  // fecha es de tipo YYYY-MM-DD y devuelve YYYYMMDD.   "0--" es el string cuando el valor de la fecha es 0
  if (fecha !== "0--" && fecha !== 0) return Number(fecha.substr(0, 4) + fecha.substr(5, 2) + fecha.substr(8, 2));
  else return 0;
}

function ano(f) {
  return Math.trunc(f / 10000);
}

function mes(f) {
  return Math.trunc((f - ano(f) * 10000) / 100);
}

function dia(f) {
  return f - (ano(f) * 10000 + mes(f) * 100);
}

function anoMes(f) {
  return ano(f) * 100 + mes(f);
}

function diaMesAno(fecha, tp = 1) {
  fecha = fecha.toString();

  var meses = ["", "Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Set", "Oct", "Nov", "Dic"];

  if (tp === 1) {
    return fecha.substr(6, 2) + "-" + meses[Number(fecha.substr(4, 2))] + "-" + fecha.substr(2, 2);
  } else {
    return fecha.substr(6, 2) + "-" + fecha.substr(4, 2) + "-" + fecha.substr(2, 2);
  }
}

function diaMes(fecha, tp = 1) {
  if (fecha === 0) return "sin fecha";
  fecha = fecha.toString();

  var meses = ["", "Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Set", "Oct", "Nov", "Dic"];

  if (tp === 1) {
    return fecha.substr(6, 2) + "-" + meses[Number(fecha.substr(4, 2))];
  } else {
    return fecha.substr(6, 2) + "-" + fecha.substr(4, 2);
  }
}

function mesAno(am, tp = 1) {
  am = am.toString();

  var meses = ["", "Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Set", "Oct", "Nov", "Dic"];

  if (tp === 1) {
    return meses[Number(am.substr(4, 2))] + "-" + am.substr(2, 2);
  } else {
    return am.substr(4, 2) + "-" + am.substr(2, 2);
  }
}

function masDias(fecha, dias) {
  fecha = fecha.toString();
  var r = new Date(sTOd(fecha));
  r.setDate(r.getDate() + dias);
  return dTOs(r);
}

function sTOd(fecha) {
  // fecha es de tipo string, devuelve tipo date

  fecha = fecha.toString();
  // ojo.. el constructor new Date considera al mes como uno menos del que se quiere obtener
  var r = new Date(Number(fecha.substr(0, 4)), Number(fecha.substr(4, 2)) - 1, Number(fecha.substr(6, 2)));
  r.setHours(12, 0, 0);
  return r;
}

function dTOs(fecha) {
  // fecha es de tipo date, devuelve tipo string
  var mes = fecha.getMonth() + 1 < 10 ? "0" + (fecha.getMonth() + 1) : fecha.getMonth() + 1;
  var dia = fecha.getDate() < 10 ? "0" + fecha.getDate() : fecha.getDate();
  return Number(fecha.getFullYear().toString() + mes.toString() + dia.toString());
}

function diasaHoy(fecha) {
  var t2 = sTOd(fecha).getTime();
  var d1 = new Date();
  d1.setHours(12, 0, 0);
  var t1 = d1.getTime();
  return t2 >= t1 ? Math.round((t2 - t1) / (24 * 3600 * 1000)) : -1 * Math.round((t1 - t2) / (24 * 3600 * 1000));
}

function dias(f1, f2) {
  var t2 = sTOd(f2).getTime();
  var t1 = sTOd(f1).getTime();
  return t2 >= t1 ? Math.round((t2 - t1) / (24 * 3600 * 1000)) : Math.round((t1 - t2) / (24 * 3600 * 1000));
}

function fMayor(f1, f2) {
  return f1 >= f2 ? true : false;
}

function mesAnterior(f, tipo = 0) {
  // devuelve el anomes anterior o anomes01  dependiendo del tipo
  let m = mes(f) === 1 ? 12 : mes(f) - 1;
  let a = mes(f) === 1 ? ano(f) - 1 : ano(f);
  let d = 1;
  return tipo === 0 ? a * 100 + m : a * 10000 + m * 100 + d;
}

function xMeses(f = HOY, n = 6, actual = true) {
  // devuelve array con los n meses anteriores incluyendo o no el actual
  let result = [];
  let am = 0;
  if (actual) {
    am = anoMes(f);
  } else am = mesAnterior(f);
  for (let i = 0; i < n; i++) {
    result.push(am);
    am = mesAnterior(am * 100 + 1); // mesAnterior recibe una fecha....
  }
  return result;
}

function lunesSemana(fecha, f) {
  // devuelve la fecha del dia lunes de la semana correspondiente a la fecha ( f=0 o null) o anterior (ej f=1) o posterior (ej f=-1)
  if (f === undefined) f = 0;

  let d = sTOd(fecha).getDay();
  d = !d ? -6 + f * 7 : -d - f * 7 + 1;
  return masDias(fecha, d);
}

function indiceSemanas(s1, s2) {
  // devuelve objecto con las semanas entre s1 y s2 y el indice asociado a cada una de ellas para ser utilizado como indice en vector
  let isemana = {}
  let cantidadSemanas = 0
  for (let s = s1; s <= s2; s = masDias(s, 7)) {
    isemana[lunesSemana(s, 0)] = cantidadSemanas
    cantidadSemanas++
  }
  return { isemana, cantidadSemanas }
}

function ceros(n) {
  let v = []
  for (let i = 0; i < n; i++) {
    v.push(0)
  }
  return [...v]
}

function idProy(x) { // devuelve el id del proyecto usado en regHoras:  idProy / idActividad
  var n = x.indexOf("/");
  return x.substr(0, n);
}

function idAct(x) { // devuelve el id de la actividad usado en regHoras:  idProy / idActividad
  var n = x.indexOf("/");
  return x.substr(n + 1, x.length);
}

function sumHoras(h) {
  let sum = h.reduce((a, b) => {
    return a + b;
  }, 0);
  return sum;
}
function indHOY(a) {
  // devuelve indice del vector AC correspondiente a la semana de HOY
  for (let x = 0; x < a.length; x++) {
    if (a[x] === lunesSemana(HOY, 0)) return x;
  }
}

export { diaMesAno, masDias, dTOs, sTOd, diasaHoy, fMayor, diaMes, dias, xMeses, ceros, indHOY, sumHoras, idProy, idAct }

export { mesAnterior, dia, ano, mes, anoMes, mesAno, toInput, toOutput, lunesSemana, indiceSemanas };

// constantes para graficas

var hoy = new Date();
hoy.setHours(12, 0, 0);
const HOY = dTOs(hoy);
const ANOHOY = Math.trunc(HOY / 10000);
const MESHOY = Math.trunc((HOY - ANOHOY * 10000) / 100);
const DIAHOY = HOY % 100;

const LPROY = 900; // largo en pixeles del proyecto mas largo, considerando los 3 tramos: inicio, 4 semanas, y fin
const L4SEMANAS = 800; // largo en pixeles de las 4 semanas, desde la fecha del dia en adelante
const LINI = 100; // largo en pixeles del maximo tramo desde el incio menor  de todos los proyectos hasta el dia de la fecha
const DIASMES = 28; // cantidad de dias a considerar para el grafico del proyecto (4 semanas)

export { LPROY, L4SEMANAS, LINI, HOY, DIASMES, ANOHOY, MESHOY, DIAHOY };

// codigueras ,  etiquetas, colores

//const colorActividad = ["#B18904", "#DBA901", "#FFBF00", "#FACC2E", "#F7D358", "#F5DA81", "#F3E2A9", "#F5ECCE", "#886A08"];
const colorActividad = ["#A9F5BC"]
const VERDE = "#52be80";
const ROJO = "#DC453D";
const AMARILLO = "#f4d03f";
const BLANCO = "white";

const colores = {
  riesgos: {
    Alto: ROJO,
    Medio: AMARILLO,
    Bajo: VERDE,
    Todos: BLANCO,
  },
  prioridad: {
    Alta: ROJO,
    Media: AMARILLO,
    Baja: VERDE,
    Alto: ROJO,
    Medio: AMARILLO,
    Bajo: VERDE,
  },
  semaforo: {
    Rojo: ROJO,
    Amarillo: AMARILLO,
    Verde: VERDE,
  },
};

const codiguera = {
  cambios: {
    Aprobado: "aprobado",
    "No aprobado": "no aprobado",
    Cerrado: "cerrado",
    Pendiente: "pendiente",
    Todos: "Todos",
  },
  riesgos: {
    Alto: "Alto",
    Medio: "Medio",
    Bajo: "Bajo",
    Todos: "Todos",
  },
  acciones: {
    Alcance: "alcance",
    Cronograma: "cronograma",
    Recursos: "recursos",
    Todas: "Todas",
  },
  funciones: {
    Roles: "Roles",
    Categorias: "Categorías",
    Evaluación: "Evaluación",
    Usuarios: "Usuarios",
  },
  semaforo: {
    Rojo: "Rojo",
    Amarillo: "Amarillo",
    Verde: "Verde",
    Todos: "Todos",
  },
  categorias: {
    Compras: "compras",
    Ventas: "ventas",
    Localizador: "localizador",
    Facturacion: "facturacion",
    Agendas: "agendas",
    Todos: "Todos",
  },
  prioridad: {
    Alta: "Alta",
    Media: "Media",
    Baja: "Baja",
    Todos: "Todos",
  },
  tipo: {
    Correctivo: "correctivo",
    Mejora: "mejora",
    Todos: "Todos",
  },
  tipoHistoria: {
    Funcionalidad: "funcionalidad",
    Investigación: "investigación",
    Ambiente: "ambiente",
    Todos: "Todos",
  },
  estadoHistoria: {
    Pendiente: "pendiente",
    Asignado: "asignado",
    Ejecutando: "ejecutando",
    Probando: "probando",
    Finalizado: "finalizado",
    "...en uso...": "...en uso...",
    Todos: "Todos",
  },
  estadoIncidentes: {
    Pendiente: "pendiente",
    Ejecutando: "ejecutando",
    Suspendido: "suspendido",
    Cerrado: "cerrado",
    Cancelado: "cancelado",
    Todos: "Todos",
  },
};

export { codiguera, VERDE, ROJO, AMARILLO, BLANCO, colorActividad, colores };

// constantes para edicion

const bkMain = "white"
const bkSubMain = "#F2F2F2"
const borderSubMain = "#E6E6E6"
const bkNavegacion = "#424949"
const bkProtector = "#e6e6e6"
const bkSeleccion = "#e6e6e6"
const clBasic = "#424242"

const bkPopUp = "white"
const clPopUp = clBasic

const bkCabGrilla = clBasic
const clCabGrilla = "white"
const bkCeldaGrilla = "white"
const clCeldaGrilla = clBasic
const sizeCelda = "1.8vh"
const sizeCabezal = "2.4vh"

const sizeEtiqueta = "2.1vh"
const bkEtiqueta = ""
const clEtiqueta = clBasic

const sizeInput = "2vh"
const bkInput = "white"
const clInput = clBasic

const sizeFiltros = "1.8vh"
const Sfiltros = {
  display: "flex",
  flexDirection: "row",
  position: "relative",
  background: "white",
  margin: "5px 0px 5px 0px",
  borderBottom: `2px solid ${borderSubMain}`,
  fontSize: sizeFiltros,
  color: clBasic,
  whiteSpace: "nowrap",
  overflow: "hidden",
  width: "100%"
};
const Sfiltro = {
  display: "flex",
  flexDirection: "row",
  margin: "5px",
  itemAlign: "center"
};
const SetiquetaFiltro = {
  fontWeight: 500,
  padding: "5px",
  marginLeft: "5px"
};
const SinputFiltro = {
  padding: "5px",
  background: "#E6E6E6",
  textAlign: "center",
  cursor: "pointer",
  borderRadius: "5px",
  border: "2px solid white"
};
const SfotoFiltro = {
  clipPath: "circle(50%)",
  margin: "auto",
  minWidth: "35px"
};

const SEtiqueta = {
  padding: "10px 0px 6px 6px",
  fontSize: sizeEtiqueta,
  fontWeight: "700",
  color: clEtiqueta,
  borderBottom: `1px solid ${clEtiqueta}`,
  background: bkEtiqueta,
  overflow: "hidden"
};

const SInput = {
  padding: "10px 0px 6px 6px",
  fontSize: sizeInput,
  border: "2px",
  borderRadius: "5px",
  background: bkInput,
  color: clInput,
  overflow: "hidden"
};

const SInputD = {
  width: "100%", //"32vw",
  height: "30vh",
  border: "2px",
  padding: "10px 0px 6px 6px",
  fontSize: sizeInput,
  borderRadius: "5px",
  resize: "none",
  background: bkInput,
  color: clInput
};

const Scrudo = {
  background: bkSubMain,
  border: `2px solid ${borderSubMain}`,
  borderRadius: "10px",
  padding: "20px"
};

const bbottomGrilla = `1px solid ${clBasic}`;

export { SInput, SInputD, SEtiqueta, clInput, sizeFiltros, bkEtiqueta, clEtiqueta, sizeEtiqueta, sizeInput, bkInput, bkSeleccion }

export { bkPopUp, clPopUp, bbottomGrilla, Scrudo, SinputFiltro, SetiquetaFiltro, SfotoFiltro, Sfiltro, Sfiltros }

export { bkProtector, sizeCelda, bkMain, bkSubMain, borderSubMain, bkNavegacion, clBasic, bkCabGrilla, clCabGrilla, bkCeldaGrilla, clCeldaGrilla, sizeCabezal }
